import { render, staticRenderFns } from "./MsUserNav.vue?vue&type=template&id=bf5c1c5e&scoped=true"
import script from "./MsUserNav.vue?vue&type=script&lang=js"
export * from "./MsUserNav.vue?vue&type=script&lang=js"
import style0 from "./MsUserNav.vue?vue&type=style&index=0&id=bf5c1c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5c1c5e",
  null
  
)

export default component.exports